var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcoLinkedin = function SvgIcoLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.336
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 164",
    fill: "#35272a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 104",
    d: "M.357 5.779h3.716v11.557H.357z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "M2.196 4.266a2.134 2.134 0 1 0-2.2-2.133 2.166 2.166 0 0 0 2.2 2.133Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39",
    d: "M10.014 11.27c0-1.625.777-2.593 2.264-2.593 1.366 0 2.023.929 2.023 2.593v6.067h3.7v-7.318c0-3.095-1.823-4.593-4.368-4.593a4.2 4.2 0 0 0-3.618 1.91V5.78H6.45v11.557h3.565Z",
    fill: "#35272a"
  })));
};

export default SvgIcoLinkedin;